module.exports = __webpack_public_path__ + "img/medicare-doctor.ae90b64f.jpg";